import type { ICampaignTemplate } from '~/modules/campaign-template/types';
import type { IShopifyPageAssignedData } from '~/modules/shopify';

import { IModalPreviewType } from '../types';
import { create } from 'zustand';

export interface IModalPreviewCampaignState {
  isOpenModalPreviewCampaign: boolean;
  modalPreviewCampaignType: IModalPreviewType;
  hasActionOnModal: boolean;
  timeStartOpenModal: number;
  selectedCampaign: ICampaignTemplate | undefined;
  selectedCampaignPage: IShopifyPageAssignedData | undefined;
}

export interface IModalPreviewCampaignAction {
  openModalPreviewCampaign: (data: { modalPreviewCampaignType: IModalPreviewType }) => void;
  closeModalPreviewCampaign: () => void;
  setSelectedCampaign: (data: ICampaignTemplate) => void;
  setSelectedCampaignPage: (data: IShopifyPageAssignedData) => void;
  setHasActionOnModal: (data: boolean) => void;
}

export type IModalPreviewCampaignStore = IModalPreviewCampaignState & IModalPreviewCampaignAction;

export const useModalPreviewCampaignStore = create<IModalPreviewCampaignStore>((set) => ({
  isOpenModalPreviewCampaign: false,
  modalPreviewCampaignType: IModalPreviewType.PREVIEW,
  selectedCampaign: undefined,
  selectedCampaignPage: undefined,
  hasActionOnModal: false,
  timeStartOpenModal: 0,
  openModalPreviewCampaign: ({ modalPreviewCampaignType }) =>
    set({
      isOpenModalPreviewCampaign: true,
      modalPreviewCampaignType,
      timeStartOpenModal: Date.now(),
    }),
  closeModalPreviewCampaign: () =>
    set({ isOpenModalPreviewCampaign: false, hasActionOnModal: false }),
  setSelectedCampaign: (data) => set({ selectedCampaign: data }),
  setSelectedCampaignPage: (data) => set({ selectedCampaignPage: data }),
  setHasActionOnModal: (data) => set({ hasActionOnModal: data }),
}));
